module.exports = __webpack_public_path__ + "static/media/camera.38ec0b82.svg";